
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

export const useLogout = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      setIsLoggingOut(true);
      
      // Clear localStorage data that might be causing issues
      localStorage.removeItem('superUserEditingFor');
      
      // First navigate to login page with logout=true parameter
      // This allows the AuthGuard to know we're trying to log out
      navigate("/login?logout=true", { replace: true });
      
      // Then attempt to sign out from Supabase
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        throw error;
      }
      
      toast({
        description: "התנתקת בהצלחה",
      });
      
    } catch (error) {
      console.error("Error logging out:", error);
      toast({
        variant: "destructive",
        title: "שגיאה בהתנתקות",
        description: "אירעה שגיאה בעת ההתנתקות מהמערכת",
      });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return { logout, isLoggingOut };
};
